module.exports = __webpack_public_path__ + "static/media/screen5.0a8427d6.png";